/*
 * @Author: Dong
 * @Date: 2022-05-06 13:26:20
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-10-21 09:13:49
 */
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Switch, Tooltip } from 'sup-ui';
import Modal from 'root/components/CommonModal';
import messages from '../messages';
import styles from './index.less';
import { getMinioInfo, operationMinio } from 'root/services/syncBack';
import { syncBack } from 'root/store/actions';
import { useDispatch } from 'react-redux';
import { formatDate, convertSecToHHmmss } from 'root/utils/utils';
import Icon from 'root/components/Icon';

const { confirm } = Modal;
let timer: any;

const Minio = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [dataInfo, setDataInfo] = useState<any>({});

  useEffect(() => {
    getInfo();
    return () => {
      // 组件将要卸载 清除定时器
      clearTimeout(timer);
      timer = null;
    };
  }, []);

  // 获取minio信息
  const getInfo = () => {
    getMinioInfo().then((res: any) => {
      const { action } = res.data;
      setDataInfo(res.data);

      // 如果正在开始备份 需要轮循获取最新信息
      if (action === 'start') {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          getInfo();
        }, 16 * 1000);
      }
    });
  };

  // 开关同步备份
  const handleChangeOpen = () => {
    if (dataInfo.action === 'start') {
      confirm({
        title: intl.formatMessage(messages.confirmColse),
        onOk: colseMinioBackup,
      });
      return;
    }
    const { free, size } = dataInfo.message;

    if (free - size < 0) {
      const remainSize = size - free;
      confirm({
        title: intl.formatMessage(messages.confirmSpaceTip, { size: `${remainSize}` }),
      });
      return;
    }
    // 满足条件，开始备份
    confirm({
      title: intl.formatMessage(messages.confirmMinioBackupTip),
      onOk: handleOk,
    });
  };

  // 开启minio备份
  const handleOk = () => {
    operationMinio({ action: 'start' }).then(() => {
      dispatch(syncBack.getLogRecord());
      getInfo();
    });
  };

  // 关闭minio备份
  const colseMinioBackup = () => {
    operationMinio({ action: 'stop' }).then(() => {
      dispatch(syncBack.getLogRecord());
      getInfo();
    });
  };
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        {intl.formatMessage(messages.annex)}
        <Tooltip title={intl.formatMessage(messages.minioIntroduce)} overlayClassName={styles.TooltipBox}>
          <div>
            <Icon type="tip16" className={styles.titleTipIcon} />
          </div>
        </Tooltip>
      </h2>

      <div className={styles.content}>
        <div className={styles.switchBox}>
          <span>{intl.formatMessage(messages.increment)}</span>
          <Switch size="small" checked={dataInfo.action === 'start'} onChange={handleChangeOpen} />
        </div>
        <ul className={styles.detailBox}>
          {dataInfo?.action !== 'start' && (
            <li>
              <span>
                {intl.formatMessage(messages.lastSyncTime)} : {formatDate(Number(dataInfo?.message?.time)) || '----'}
              </span>
            </li>
          )}

          <li>
            {intl.formatMessage(messages.startTime)} : {formatDate(Number(dataInfo.start)) || '----'}
          </li>
          {dataInfo?.action === 'start' && (
            <li>
              {intl.formatMessage(messages.runned)} : {convertSecToHHmmss(Number(dataInfo.message?.runned)) || '----'}
            </li>
          )}
          <li>
            {intl.formatMessage(messages.filePath)} : {dataInfo?.path || '----'}
          </li>
          <li>
            {intl.formatMessage(messages.fileSize)} :{` ${dataInfo?.message?.executed}GB` || '----'}
          </li>
        </ul>
        {dataInfo.action === 'start' ? (
          <div className={styles.doingBackup}>
            {intl.formatMessage(messages.doingBackup)}
            {dataInfo.logs}......
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Minio;
